var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"monitorSite px-4",attrs:{"fluid":""}},[_c('br'),_c('h1',[_vm._v(_vm._s(this.reportTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }